import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/lib/adminApi";
import { toast } from "sonner";

function fmtErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-aria-ink px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <img src="/aria-logo-light.png" alt="ARIA — Cocktails Experience" className="mb-4 h-14 w-auto" />
        <div className="mb-12 text-[0.7rem] uppercase tracking-[0.28em] text-aria-brass">Studio · Admin</div>
        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="mb-2 block text-[0.65rem] uppercase tracking-[0.2em] text-aria-ivory/50">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-0 border-b border-aria-ivory/20 bg-transparent py-3 text-lg text-aria-ivory placeholder:text-aria-ivory/30 focus:border-aria-brass focus:outline-none"
              placeholder="admin@ariadrinks.com"
            />
          </div>
          <div>
            <label className="mb-2 block text-[0.65rem] uppercase tracking-[0.2em] text-aria-ivory/50">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-0 border-b border-aria-ivory/20 bg-transparent py-3 text-lg text-aria-ivory placeholder:text-aria-ivory/30 focus:border-aria-brass focus:outline-none"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-aria-brass py-4 text-[0.72rem] uppercase tracking-[0.24em] text-aria-ink transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter Studio"}
          </button>
        </form>
      </div>
    </div>
  );
}
